import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.1905 0H1.52381C0.678095 0 0 0.685714 0 1.52381V12.1905C0 13.0286 0.678095 13.7143 1.52381 13.7143H4.57143L6.85714 16L9.14286 13.7143H12.1905C13.0286 13.7143 13.7143 13.0286 13.7143 12.1905V1.52381C13.7143 0.685714 13.0286 0 12.1905 0ZM12.1905 12.1905H8.51048L8.06095 12.64L6.85714 13.8438L5.64571 12.6324L5.20381 12.1905H1.52381V1.52381H12.1905V12.1905ZM6.09524 9.90476H7.61905V11.4286H6.09524V9.90476ZM6.85714 3.80952C7.69524 3.80952 8.38095 4.49524 8.38095 5.33333C8.38095 6.85714 6.09524 6.66667 6.09524 9.14286H7.61905C7.61905 7.42857 9.90476 7.2381 9.90476 5.33333C9.90476 3.64952 8.54095 2.28571 6.85714 2.28571C5.17333 2.28571 3.80952 3.64952 3.80952 5.33333H5.33333C5.33333 4.49524 6.01905 3.80952 6.85714 3.80952Z",
		fill: "#4F4F4F"
	})
});
export default SvgQuestion;
